import {RouteContainer, RouteType} from 'b302-frontend-library';
import Demo from '../../components/client/pages/Demo';
import Explore from '../../components/client/pages/Explore';
import Home from '../../components/client/pages/Home';
import UniversityDetail from '../../components/client/pages/university-detail/UniversityDetail/UniversityDetail';
import Contact from '../../components/client/pages/Contact/Contact';
import CompareFacilities from '../../components/client/pages/compare/CompareFacilities/CompareFacilities';
import Universities from '../../components/client/pages/Universities';
import Favorites from '../../components/client/pages/Favorites';
import SubjectAreas from '../../components/client/pages/subject-area/SubjectAreas';
import CompareProgram from '../../components/client/pages/compare/CompareProgram';
import CompareCosts from '../../components/client/pages/compare/CompareCosts/CompareCosts';
import CompareAccommodation from '../../components/client/pages/compare/CompareAccommodation';
import SelectRegions from '../../components/client/pages/SelectRegions/SelectRegions';
import Compare from '../../components/client/pages/compare/Compare';

const routeContainer = new RouteContainer();

routeContainer.add('/', Home, 'home');
routeContainer.add('/universities', Universities, 'universities');
routeContainer.add('/explore', Explore, 'explore');
routeContainer.add('/demo', Demo, 'demo');
routeContainer.add('/select-regions', SelectRegions, 'select-regions');
routeContainer.add('/compare/:ids', Compare, 'compare-universities');
routeContainer.add('/compare/:ids/facilities', CompareFacilities, 'compare-facilities');
routeContainer.add('/compare/:ids/program', CompareProgram, 'compare-program');
routeContainer.add('/compare/:ids/costs', CompareCosts, 'compare-costs');
routeContainer.add('/compare/:ids/accommodation', CompareAccommodation, 'compare-accommodation');
routeContainer.add('/universities/:id', UniversityDetail, 'university-detail');

routeContainer.add('/favorites', Favorites, 'favorite-universities');
routeContainer.add('/subject-areas', SubjectAreas, 'subject-areas');

routeContainer.group('/universities', () => {
    routeContainer.add('/:id', UniversityDetail, 'university-detail');
    routeContainer.add('/:id/contact', Contact, 'university-contact');
}, RouteType.PUBLIC);

routeContainer.groupType(RouteType.PRIVATE, () => {
    routeContainer.add('/dashboard', Explore, 'dashboard');
});

export default routeContainer.getRoutes();
